import React from 'react';
import {
    Box, Typography, Button, Paper, Slide,
    List, ListItem, ListItemText, ListItemAvatar, Avatar, Divider, IconButton
} from '@mui/material';
import {
    Close as CloseIcon, CompareArrows as CompareArrowsIcon,
    Download as DownloadIcon
} from '@mui/icons-material';

const ShortlistSidebar = ({
    shortlist,
    onClose,
    onToggle,
    onCompare,
    onExport
}) => {
    return (
        <Slide direction="left" in={shortlist.length > 0} mountOnEnter unmountOnExit>
            <Paper
                elevation={4}
                sx={{
                    width: 320,
                    flexShrink: 0,
                    height: 'calc(100% - 32px)', // Adjust height for margin
                    display: 'flex',
                    flexDirection: 'column',
                    borderLeft: 1,
                    borderColor: 'divider',
                    my: 7, // Add 16px margin top and bottom
                    mr: 2, // Add 16px margin right
                    borderRadius: 4, // Add border radius for a card-like look
                }}
            >
                {/* Header */}
                <Box sx={{ p: 2.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                    <Typography variant="h6" sx={{fontWeight: 600}}>Shortlist ({shortlist.length})</Typography>
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </Box>
                <Divider />

                {/* List of Candidates */}
                <List sx={{ flexGrow: 1, overflowY: 'auto', p: 2 }}>
                    {shortlist.map(c => (
                        <ListItem
                            key={c.uuid}
                            disablePadding
                            sx={{
                                mb: 1.5,
                                p: 1.5, // Added padding
                                borderRadius: 2, // Rounded corners for items
                                bgcolor: 'action.hover' // Slight background color
                            }}
                            secondaryAction={
                                <IconButton edge="end" onClick={() => onToggle(c.uuid)}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        >
                            <ListItemAvatar>
                                <Avatar sx={{bgcolor: 'primary.main', color: 'primary.contrastText'}}>{c.name.charAt(0)}</Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={c.name}
                                secondary={c.email}
                                primaryTypographyProps={{ fontWeight: 500, noWrap: true }}
                                secondaryTypographyProps={{ noWrap: true, }} // This line prevents the email from wrapping
                            />
                        </ListItem>
                    ))}
                </List>
                <Divider />

                {/* Footer Actions */}
                <Box sx={{ p: 2.5, flexShrink: 0 }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<CompareArrowsIcon />}
                            disabled={shortlist.length < 2}
                            onClick={onCompare}
                            sx={{borderRadius: '99px', textTransform: 'none', py: 1}}
                        >
                            Compare
                        </Button>
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<DownloadIcon />}
                            onClick={onExport}
                            sx={{borderRadius: '99px', textTransform: 'none', py: 1}}
                        >
                            Export
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    );
};

export default ShortlistSidebar;